






































































































import { ajax } from 'jquery';
import { formatDistanceToNow, parseISO, format } from 'date-fns';
import Vue from 'vue';

import { VBTooltip, BButton } from 'bootstrap-vue';
import { ProfileIcon } from 'zenComponents';
import CommentsInput from './CommentsInput.vue';
import { loadSiteConfig, loadMentionUserList } from '@/utils/crudActions';
import { keysToCamel } from '@/utils/utils';

export default Vue.extend({
  name: 'Comments',
  components: {
    BButton,
    CommentsInput,
    ProfileIcon,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
    commentList: {
      type: Array,
      required: true,
    },
    canComment: {
      type: Boolean,
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    inverseDirection: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sendDisabled: <boolean>false,
      people: [],
      loadingPeople: true, // TODO add loading spinner in the view
      editorContent: {
        html: '',
        mentions: [],
      },
      config: {},
    };
  },
  computed: {
    comments() {
      if (this.inverseDirection) {
        return this.commentList
          .map(o => keysToCamel(o))
          .slice()
          .reverse();
      } else {
        return this.commentList.map(o => keysToCamel(o)).slice();
      }
    },
    customPillClasses() {
      return [
        {
          class: 'me',
          id: this.config.currentUser.dbId,
        },
      ];
    },
  },
  updated: function() {
    // TODO: temp, scrolling should be handled in the component
    this.$nextTick(function() {
      if (!this.inverseDirection) this.$emit('scrollToBottom');
    });
  },
  async created() {
    this.fetchConfig();
  },
  methods: {
    getUser(comment) {
      if (this.people) {
        // is a mention, return user if exists in people
        const user = this.people.find(p => p.id == comment.ownerId);
        return user;
      }
    },
    onEditorChanged(content) {
      this.editorContent = content;
    },
    async fetchConfig() {
      this.loadingPeople = true;
      try {
        this.config = await loadSiteConfig();
        const userList = await loadMentionUserList({
          csrf: this.csrf,
          id: this.objectId,
          type: this.objectType,
        });
        if (userList && userList.users) {
          this.people = userList.users.map(user => {
            if (!user.name) user.name = user.email;
            return user;
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      this.loadingPeople = false;
    },
    enterHandler(ev: KeyboardEvent) {
      if (ev.metaKey || ev.ctrlKey) {
        this.send();
      }
    },
    showActionsDropdown(comment: any): boolean {
      return comment.canEdit || comment.canDelete;
    },
    send() {
      const comment = this.editorContent.html;
      const mentions = this.editorContent.mentions;
      // Track mentions on segment
      if (window.analytics) {
        analytics.track('Comment Mentions', {
          objectType: this.objectType,
          mentions: mentions.length,
        });
      }

      if (comment && comment.length && !this.sendDisabled) {
        this.sendDisabled = true;
        ajax({
          type: 'POST',
          url: this.apiUrl,
          headers: { 'X-CSRF-Token': this.csrf },
          data: JSON.stringify({
            object_type: this.objectType,
            object_id: this.objectId,
            comment_description: comment,
            mentions,
          }),
          contentType: 'application/json',
          success: response => {
            if (this.inverseDirection) {
              this.comments.unshift(keysToCamel(response));
            } else {
              this.comments.push(keysToCamel(response));
            }

            this.$refs.componentsInput.editor.clearContent(true);
            this.sendDisabled = false;
          },
          error: () => {
            const showAlert = this.$store ? config => this.$store.dispatch('alerts/show', config) : window.GGRC.Notify;
            const alertConfig = {
              type: 'error',
              message:
                "Oops, can't add a comment. " +
                'Please try again, refresh your page or contact ' +
                'your administrator.',
            };

            showAlert(alertConfig);
            this.sendDisabled = false;
          },
        });
      }
    },
    distanceDate(date: string): string {
      return formatDistanceToNow(parseISO(date), { addSuffix: true });
    },
    formatDate(date: string): string {
      return format(parseISO(date), `MM/dd/yyyy 'at' h:mm a`);
    },
    getModifiedTooltipText(comment: any): string {
      return `Edited on ${this.formatDate(comment.updatedAt)} ` + `by ${comment.modifiedBy}`;
    },
    async onEditClick(comment: any): void {
      const showModal = this.$store ? config => this.$store.dispatch('modals/show', config) : window.GGRC.zenModal.show;
      const modalConfig = {
        type: 'EditCommentModal',
        data: {
          initialComment: comment,
          csrfToken: this.csrf,
          people: this.people,
          objectType: this.objectType,
          objectId: this.objectId,
          customPillClasses: this.customPillClasses,
        },
        config: {
          ignoreUrl: true,
        },
      };

      try {
        await showModal(modalConfig);
        this.$emit('refresh');
      } catch {
        // User closed modal
      }
    },
    async onDeleteClick(comment: any): void {
      const showModal = this.$store ? config => this.$store.dispatch('modals/show', config) : window.GGRC.zenModal.show;
      const modalConfig = {
        type: 'OldDeleteCard',
        data: {
          bulkCount: 0,
          axiosRequest: {
            method: 'DELETE',
            url: `/api/v2/comments/${comment.id}`,
            headers: {
              'X-CSRF-Token': this.csrf,
            },
          },
          objectType: 'Comment',
          objectTitle: 'the comment',
          italicizeObjectTitle: false,
        },
        config: {
          ignoreUrl: true,
        },
      };

      try {
        await showModal(modalConfig);
        this.$emit('refresh');
      } catch {
        // User closed modal
      }
    },
  },
});
